module.exports = "/_next/static/images/MakeDataDrivenDecisions@2x-9bbaeff21a42eb6c3af6743dad18cc9c.webp";